<div class="headerdiv">
  <h1>Override Price Management</h1>
</div>

<!-- Price - Search and List -->
<div [hidden]="viewpage" *ngIf="actionmode != 'Add' && actionmode != 'Edit' && actionmode != 'View'">
  <div class="card-body">
    <div class="col-md-12">
      <div class="bothbuttdiv mt-1">
        <button class="btn btn-primary commonbutt" type="button" (click)="addForm()">
          <em class="fa fa-plus-circle"></em>&nbsp;Add New
        </button>
      </div>
      <div class="mt-4">
        <div class="card-body">
          <div class="col-md-12">
            <div class="mt-2 mb-2">
              <div class="row">
                <div class="col-md-4 column_width align-items-center">
                  <div class="form-group ">
                    <label>Origin</label>
                    <input type="text" maxlength="3" [(ngModel)]="price.origin" (input)="keyupevent($event)"
                      class="form-control text-uppercase" />
                  </div>
                </div>
                <div class="col-md-4 column_width align-items-center">
                  <div class="form-group ">
                    <label>Destination</label>
                    <input type="text" maxlength="3" [(ngModel)]="price.destination" (input)="keyupevent($event)"
                      class="form-control text-uppercase" />
                  </div>
                </div>
                <div class="col-md-4 column_width align-items-center">
                  <div class="form-group">
                    <label>TPM Value</label>
                    <input type="text" [(ngModel)]="price.tpmValue" class="form-control text-uppercase" readonly />
                  </div>
                </div>
              </div>

              <div class="row mt-1 mb-2">
                <div class="col-md-4 mt-2 column_width align-items-center">
                  <ng-multiselect-dropdown-angular7 placeholder="Select the Tier" [settings]="dropdownSettings"
                    [data]="tiers" [(ngModel)]="price.tier" (onSelect)="onItemSelect($event)"
                    (onSelectAll)="onSelectAll($event)">
                  </ng-multiselect-dropdown-angular7>
                </div>

                <div class="col-md-4 mt-2 column_width align-items-center">
                  <mat-form-field class="w-picker">
                    <input id="did" #input1 matInput [matDatepicker]="pickerFrom"
                      (dateChange)="incresedate(); isEmpty()" autocomplete="off" placeholder="From Date (Travel)"
                      readonly [min]="myDate" [(ngModel)]="price.FROM_DATE" />
                    <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                    <mat-datepicker #pickerFrom></mat-datepicker>
                  </mat-form-field>

                  <button type="button" class="close opa" (click)="resetFrom(); checkStatusFrom()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <br />
                </div>

                <div class="col-md-4 mt-2 column_width align-items-center">
                  <mat-form-field class="w-picker">
                    <input #input2 matInput [disabled]="!isFromDateFilled" [matDatepicker]="pickerTo" (dateChange)="isEmpty()"
                      autocomplete="off" placeholder="To Date (Travel)" readonly
                      [(ngModel)]="price.TO_DATE" [min]="price.FROM_DATE" />
                    <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                    <mat-datepicker #pickerTo></mat-datepicker>
                  </mat-form-field>

                  <button type="button" class="close opa" (click)="clearToDate(); checkStatusFrom()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <br />
                </div>


                <!-- <div>
                  <app-shared-datepicker [final]="final" [isEndDate]="isEndDate" (resetTo)="resetTo($event)"
                    (isEmpty)="isEmpty($event)" (toDateEvent)="setToDate($event)" [toDateflag]="toDateflag">
                  </app-shared-datepicker>
                </div> -->
              </div>

              <div class="mb-2 btn-right">
                <button class="btn btn-primary commonbutt" type="button" (click)="searchPrice()">
                  <em class="fa fa-search"></em>&nbsp;Search
                </button>
              </div>
            </div>

            <div style="margin-top: 6rem;" *ngIf="listPrice != '' || listPrice != 0">
              <table aria-describedby="priceOverrideData" class="table table-striped mt-3" *ngIf="!loader" [mfData]=""
                [mfRowsOnPage]="5">
                <thead>
                  <tr>
                    <th scope="col" class="text-center">Tier</th>
                    <th scope="col" class="text-center">Origin</th>
                    <th scope="col" class="text-center">Destination</th>
                    <th scope="col" class="text-center">TPM</th>
                    <th scope="col" class="text-center">From Date (DD/MM/YYYY)</th>
                    <th scope="col" class="text-center">To Date (DD/MM/YYYY)</th>
                    <th scope="col" class="text-center">FP1</th>
                    <th scope="col" class="text-center">FP2</th>
                    <th scope="col" class="text-center">FP3</th>
                    <th scope="col" class="text-center">FP4</th>
                    <th scope="col" class="text-center">FP5</th>
                    <th scope="col" class="text-center">FP6</th>
                    <th scope="col" class="text-center">FP7</th>
                    <th scope="col" class="text-center">Status</th>
                    <th scope="col" class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="link" *ngFor="
                let price of listPrice
                  | paginate
                    : {
                        itemsPerPage: 10,
                        currentPage: p,
                        totalItems: totalItems
                      };
                let id = index
              ">
                    <td class="text-center">
                      {{ price.TIER }}
                    </td>
                    <td class="text-center">
                      {{ price.ORIGIN }}
                    </td>
                    <td class="text-center">
                      {{ price.DESTINATION }}
                    </td>
                    <td class="text-center">
                      {{ price.TPM }}
                    </td>
                    <td class="text-center">
                      {{ price.FROM_DATE | date: "d/MM/y" }}
                    </td>
                    <td class="text-center">{{ price.TO_DATE | date: "d/MM/y" }}</td>
                    <td>

                      <span *ngIf="isedit!= id || isedit===''">{{ price.FP1 }}</span>
                      <input *ngIf="isedit === id " [(ngModel)]="FP1" size="1">

                    </td>
                    <td class="text-center">
                      <span *ngIf="isedit!= id || isedit===''"> {{ price.FP2 }}</span>
                      <input *ngIf="isedit === id" [(ngModel)]="FP2" size="1">

                    </td>
                    <td class="text-center">
                      <span *ngIf="isedit != id || isedit===''">{{ price.FP3 }} </span>
                      <input *ngIf="isedit === id" [(ngModel)]="FP3" size="1">

                    </td>
                    <td class="text-center">
                      <span *ngIf="isedit != id || isedit===''">{{ price.FP4 }} </span>
                      <input *ngIf="isedit === id" [(ngModel)]="FP4" size="1">

                    </td>
                    <td class="text-center">
                      <span *ngIf="isedit != id || isedit===''">{{ price.FP5 }} </span>
                      <input *ngIf="isedit === id" [(ngModel)]="FP5" size="1">

                    </td>
                    <td class="text-center">
                      <span *ngIf="isedit != id || isedit===''">{{ price.FP6 }} </span>
                      <input *ngIf="isedit === id" [(ngModel)]="FP6" size="1">

                    </td>
                    <td class="text-center">
                      <span *ngIf="isedit != id || isedit===''"> {{ price.FP7 }} </span>
                      <input *ngIf="isedit === id" [(ngModel)]="FP7" size="1">

                    </td>
                    <td class="text-center">
                      <span *ngIf="isedit != id || isedit===''"> {{ price.STATUS }} </span>
                      <select *ngIf="isedit === id " (change)="selectdropdown($event)" [(ngModel)]="selectedValue">
                        <option value="ACTIVE">ACTIVE</option>
                        <option value="INACTIVE">INACTIVE</option>

                      </select>

                    </td>

                    <td class="text-center">

                      <span *ngIf="isedit === id" class="glyphicon glyphicon-ok mr-1"
                        (click)="Save(price.ID, editContent)"></span>
                      <span *ngIf="isedit != id || isedit=== ''" class="glyphicon glyphicon-edit mr-1"
                        (click)="editData(price.ID,editContent,id)"></span>
                      <span class="glyphicon glyphicon-remove mr-1" *ngIf="isedit === id"
                        (click)="cancel(price.ID,editContent)"></span>
                      <span *ngIf="isedit != id || isedit===''" class="glyphicon glyphicon-trash" data-toggle="modal"
                        data-target="#deleteModal" (click)="deleteData(price.ID, deleteContent)"></span>
                    </td>

                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="16">
                      <pagination-controls (pageChange)="pageCount($event)" total-items="totalItems">
                      </pagination-controls>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div style="margin-top: 6rem;" *ngIf="loader">
              <div style="margin: 20 auto; text-align: center;">
                  <img src="../../../assets/img/Loading_Animation.gif" width="4%" height="4%"
                      alt="Loader" />
              </div>
            </div>
            <div class="mt-6" *ngIf="listPrice == '' || listPrice == 0">
              <h1 style="text-align:center" *ngIf="noresult != ''" id="noresulrErr">
                {{ noresult }}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add New Price -->
<div *ngIf="actionmode == 'Add'">
  <div class="card-body">
    <div class="col-md-12">
      <div class="mt-2">
        <div class="row">
          <div class="col-md-4 column_width align-items-center">
            <div class="form-group ">
              <label>Origin</label>
              <input type="text" maxlength="3" [(ngModel)]="price.origin" (input)="keyupevent($event)"
                class="form-control text-uppercase" />
            </div>
          </div>
          <div class="col-md-4 column_width align-items-center">
            <div class="form-group ">
              <label>Destination</label>
              <input type="text" maxlength="3" [(ngModel)]="price.destination" (input)="keyupevent($event)"
                class="form-control text-uppercase" />
            </div>
          </div>
          <div class="col-md-4 column_width align-items-center">
            <div class="form-group">
              <label>TPM Value</label>
              <input type="text" [(ngModel)]="price.tpmValue" class="form-control text-uppercase" readonly />
            </div>
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-md-4 mt-2 column_width align-items-center">
            <ng-multiselect-dropdown-angular7 placeholder="Select the Tier" [settings]="dropdownSettings" [data]="tiers"
              [(ngModel)]="price.tier" (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
            </ng-multiselect-dropdown-angular7>
          </div>

          <div class="col-md-4 mt-2 column_width align-items-center">
            <mat-form-field class="w-picker">
              <input id="did" #input1 matInput [matDatepicker]="pickerFrom" (dateChange)="incresedate(); isEmpty()"
                autocomplete="off" placeholder="From Date (Travel)" readonly [min]="myDate"
                [(ngModel)]="price.FROM_DATE" />
              <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
              <mat-datepicker #pickerFrom></mat-datepicker>
            </mat-form-field>

            <button type="button" class="close opa" (click)="resetFrom(); checkStatusFrom()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <br />
          </div>
          <div class="col-md-4 mt-2 column_width align-items-center">
            <mat-form-field class="w-picker">
              <input [min]="final" #input2 matInput [disabled]="isEndDate" [matDatepicker]="pickerTo"
                (dateChange)="isEmpty()" autocomplete="off" placeholder="To Date (Travel)" readonly
                [(ngModel)]="price.TO_DATE" />
              <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
              <mat-datepicker #pickerTo></mat-datepicker>
            </mat-form-field>
            <button type="button" class="close opa" (click)="resetTo()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <br />
            <span *ngIf="invaliddate" style="color: red;font-size: 10px">
              'To' date should be greater than 'From' date
            </span>
          </div>
        </div>

        <div class="mt-2">
          <label>RPM value</label>
          <table aria-describedby="overrideData" class="table table-bordered">
            <thead>
              <tr>
                <th scope="col">FP1</th>
                <th scope="col">FP2</th>
                <th scope="col">FP3</th>
                <th scope="col">FP4</th>
                <th scope="col">FP5</th>
                <th scope="col">FP6</th>
                <th scope="col">FP7</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input type="number" min="0" [(ngModel)]="price.fp1" class="form-control" />
                </td>
                <td>
                  <input type="number" min="0" [(ngModel)]="price.fp2" class="form-control" />
                </td>
                <td>
                  <input type="number" min="0" [(ngModel)]="price.fp3" class="form-control" />
                </td>
                <td>
                  <input type="number" min="0" [(ngModel)]="price.fp4" class="form-control" />
                </td>
                <td>
                  <input type="number" min="0" [(ngModel)]="price.fp5" class="form-control" />
                </td>
                <td>
                  <input type="number" min="0" [(ngModel)]="price.fp6" class="form-control" />
                </td>
                <td>
                  <input type="number" min="0" [(ngModel)]="price.fp7" class="form-control" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div *ngIf="actionmode == 'Add'" class="btn-right mt-1">
          <button class="btn btn-primary commonbutt mr-1" type="button" (click)="createPrice()">
            <em class="fa fa-check"></em>&nbsp;Submit
          </button>

          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete Modal -->
<ng-template #deleteContent>
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      <strong>Delete Price Details</strong>
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h4>Are you sure you want to delete?</h4>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()" data-dismiss="modal">
      No
    </button>
    <button type="button" class="btn btn-primary" (click)="deletePrice()">
      Yes
    </button>
  </div>
</ng-template>

<!-- Edit Modal -->
<ng-template #editContent>
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      <strong>Price Status Details</strong>
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h4>Are you sure you want to change status?</h4>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="statusPrice('INACTIVE')">
      Inactive
    </button>
    <button type="button" class="btn btn-primary" (click)="statusPrice('ACTIVE')">
      Active
    </button>
  </div>
</ng-template>